import styled, { keyframes } from 'styled-components';
import { useCameraViewContext } from '../../context';
import { UploadStatus, useVideoUploadStatus } from 'services/listerUploadVehicle/v2';
import { useFormVehicleId } from 'pages/ListerVehicleUploadV2/hooks/useFormVehicleId';
import toast from 'react-hot-toast';

const TakeVideoButton = styled.div`
  width: 58px;
  height: 58px;
  border-radius: 100%;
  outline: 3px solid #fff;
  outline-offset: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TakeVideoButtonInner = styled.div<{ recording: boolean }>`
  border-radius: ${({ recording }) => (recording ? '4px' : '100%')};

  background: red;
  width: ${({ recording }) => (recording ? '45%' : '100%')};
  height: ${({ recording }) => (recording ? '45%' : '100%')};

  transition: border-radius 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    height 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  transform: ${({ recording }) => (recording ? 'scale(1.1)' : 'scale(1)')};
`;

export const TakeVideo = () => {
  const { startRecording, isRecording, stopRecording } = useCameraViewContext();

  const vehicleId = useFormVehicleId();
  const uploadStatus = useVideoUploadStatus(vehicleId);

  const handleClick = () => {
    if (isRecording) {
      return stopRecording();
    }

    if (uploadStatus === UploadStatus.IN_PROGRESS || uploadStatus === UploadStatus.QUEUED) {
      toast.error('Video upload is in progress');
      return;
    }

    startRecording();
  };

  return (
    <TakeVideoButton onClick={handleClick}>
      <TakeVideoButtonInner recording={isRecording} />
    </TakeVideoButton>
  );
};
